import React, { useEffect } from 'react';
import NavBar from './components/Nav/NavBar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Grid, Snackbar } from '@material-ui/core';
import SignUp from './components/Register/SignUp';
import Login from './components/Register/Login';
import { FirebaseContext } from './config';
import { useStateValue } from './session/store';
import RouteAuthenticated from './components/Security/RouteAuthenticated';
import Profile from './components/Register/Profile';


import CategoriesList from './components/Categories/CategoriesList';
import NewCategory from './components/Categories/NewCategory';
import EditCategories from './components/Categories/EditCategories'

import store from './redux/store';
import {Provider} from 'react-redux';
import SubCategory from './components/Categories/SubCategory';
import EditSubCategories from './components/Categories/EditSubCategories';
import IndexUsers from './components/PDF/IndexUsers'; 
import Print from './components/PDF/Print';
import Footer from './components/Nav/Footer';


function App() {
  let firebase = React.useContext(FirebaseContext);
  const [authStarted, setupFirebaseStarted] = React.useState(false);

  const [{openSnackbar}, dispatch] = useStateValue();

  useEffect(() => {
    firebase.isStarted().then(val=>{
      setupFirebaseStarted(val);
    })
  })

  return  authStarted !== false ? (
    <Provider store={store}>
      <React.Fragment>
        <Snackbar
          anchorOrigin = {{vertical: "bottom", horizontal: "center"}}
          open = {openSnackbar ? openSnackbar.open : false}
          autoHideDuration = {5000}
          ContentProps = {{
            "aria-describedby" : "message-id"
          }}
          message = {
            <span id="message-id">
              {openSnackbar ? openSnackbar.mensaje : ""}
            </span>
          }
          onClose = {()=>
            dispatch({
              type: "OPEN_SNACKBAR",
              openMensaje : {
                open: false,
                mensaje: ""
              }
            })
          }
        >

        </Snackbar>
        <Router>
          <NavBar/>
          <Grid container>
            <Switch>
              <RouteAuthenticated exact path="/content" 
                authFirebase={firebase.auth.currentUser} 
                component={IndexUsers}
              />
              <RouteAuthenticated 
                exact path="/profile" 
                authFirebase={firebase.auth.currentUser} 
                component={Profile}
              />
       
              <RouteAuthenticated 
                exact path="/categories" 
                authFirebase={firebase.auth.currentUser} 
                component={CategoriesList}
              /> 
              <RouteAuthenticated 
                exact path="/categories/new" 
                authFirebase={firebase.auth.currentUser} 
                component={NewCategory}
              /> 
              <RouteAuthenticated 
                exact path="/categories/:id" 
                authFirebase={firebase.auth.currentUser} 
                component={EditCategories}
              /> 
              <RouteAuthenticated 
                exact path="/categories/:id/subcategories" 
                authFirebase={firebase.auth.currentUser} 
                component={SubCategory}
              /> 
              <RouteAuthenticated 
                exact path="/categories/:id/subcategories/:id" 
                authFirebase={firebase.auth.currentUser} 
                component={EditSubCategories}
              /> 

              <Route path="/registration" exact component={SignUp}/>
              <Route path="/" exact component={Login}></Route>
            </Switch>
          </Grid>
          <Footer/>
        </Router>
      </React.Fragment>
    </Provider>
  )
  :null
  ;
}

export default App;
